import { Plugin, PluginKey } from "@tiptap/pm/state";
import { Extension } from "@tiptap/react";
import { fillEmptyTableCells } from "../lib/fillEmptyTableCells";

/**
 * 네이티브 붙여넣기(text/html)로 들어온 표의 빈 셀을 보정한다.
 *
 * 외부 앱(워드/구글독스/웹 등)에서 복사한 표는 빈 칸이 <td></td>로 오는데,
 * Tiptap tableCell/tableHeader content는 "block+"이라 빈 셀은 schema-invalid다.
 * 그대로 두면 Y.Doc 재구성(재로드/원격 동기화) 시 "Invalid content for node tableCell"로
 * 문서 전체 렌더가 깨진다(붙여넣은 표가 잠깐 보였다 사라짐).
 *
 * ProseMirror가 HTML을 DOM으로 파싱하기 직전(transformPastedHTML)에 빈 셀을 빈 문단으로
 * 채워 항상 schema-valid하게 만든다. 마크다운 텍스트 붙여넣기는 MarkdownPaste가 가로채
 * markdownToHtml에서 동일하게 보정하므로, 여기서는 네이티브 HTML 경로만 담당한다.
 */
export const EnsureTableCellContent = Extension.create({
  name: "ensureTableCellContent",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey("ensureTableCellContent"),
        props: {
          transformPastedHTML: (html) => fillEmptyTableCells(html),
        },
      }),
    ];
  },
});
